import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {


  'salescenter': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'province': {
    title: '省',
    type: 'select',
    equation: city,
    dictionary: 'region'

  },
  'city': {
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city'

 },
  'invoicingcustomer': {
    title: '开票客户编码'
  },
  'invoicingcustomername': {
    title: '开票客户名称'
  },
  'ordercustomer': {
    title: '订单客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'ordercustomername': {
    title: '订单客户名称'
  },

  'chfl': {
    title: '品牌',
    type: 'select',
    equation: city,
    dictionary: 'A0019'
  },
  'productCode': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '产品编码'
    }
  },
  'description': {
    title: '产品名称'
  },
  'fpCode': {
    title: '发票号'
  },
  'manualInvo': {
    title: '提货票'
  },
  'makeDate': {
    title: '开票日期',
    type: 'date',
    equation: all
  },
  'salePlan': {
    describe: true,
    title: '发票类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  },
  'invoiceProperty': {
    describe: true,
    title: '发票性质',
    type: 'select',
    equation: city,
    dictionary: 'inv_property'
  },
  'useQuantity': {
    title: '开票量(瓶)'
  },
  'useZzfld9': {
    title: '开票量(件)'
  },

  'transferQty': {
    title: '货权转移量'
  },
  'approvingNum': {
    title: '要货正在审批量',

  },
  'usedNum': {
    title: '要货审批完成量'

  },
  'occupancyNum': {
    title: '占用量合计'
  },
  'remainNum': {
    title: '剩余量'
  },

  'isClear': {
    title: '是否结清',
    type: 'select',
    equation: city,
    dictionary: 'settlement'
  },
  'annual': {
    title: '配额年度'
  },



}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealerInvUseDtlRptForms.js